import { render, staticRenderFns } from "./collEdit.vue?vue&type=template&id=a5dcd72a"
import script from "./collEdit.vue?vue&type=script&lang=js"
export * from "./collEdit.vue?vue&type=script&lang=js"
import style0 from "../assets/css/offerEdit.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports